var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{class:['custom-checkbox', { 'checked': _vm.isChecked }]},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.isChecked},on:{"change":_vm.handleChange}}),_c('span',{staticClass:"checkmark"}),_c('span',{staticClass:"check-label"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }